import { useState, useCallback } from "react";

import axios, { AxiosRequestConfig } from "axios";
import { message } from "antd";
import { apiV1Endpoint } from "../../../../../../../api/v1";

interface LeaseTermsPayload {
  leaseStartDate: string;
  leaseEndDate: string;
}

interface PreviewSchedulePayload {
  leaseId: string;
  leaseTerms: LeaseTermsPayload;
}

interface UsePreviewScheduleResponse {
  loading: boolean;
  error: string | null;
  data: any;
  previewSchedule: (payload: PreviewSchedulePayload) => Promise<void>;
}

export const usePreviewScheduleAmendment = (leaseTerms: Object): UsePreviewScheduleResponse => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  const previewSchedule = useCallback(
    async (payload: PreviewSchedulePayload) => {
      setLoading(true);
      setError(null);

      try {
        const res = await axios.post(`${apiV1Endpoint}/booking/previewScheduleAmendment`, payload);
        setData(res.data);
      } catch (err: any) {
        setError(err?.response?.data?.message || "Failed to preview schedule amendment");
      } finally {
        setLoading(false);
      }
    },
    [leaseTerms]
  );

  return {
    loading,
    error,
    data,
    previewSchedule,
  };
};
